<template>
  <Modal ref="modal" @hidden="reset">
    <h2 class="box__title">{{ $t('transferRow.title') }}</h2>
    <p>{{ $t('transferRow.explanation') }}</p>
    <Dropdown
      v-model="targetId"
      :disabled="busy"
      @update:model-value="plan = null"
    >
      <DropdownItem
        v-for="target in targets"
        :key="target.id"
        :value="target.id"
        :name="target.name"
      />
    </Dropdown>
    <p v-if="error" role="alert">{{ error }}</p>
    <template v-if="plan">
      <p v-if="plan.new_fields.length">
        {{ $t('transferRow.newFields') }} {{ plan.new_fields.join(', ') }}
      </p>
      <p>{{ $t('transferRow.confirmation') }}</p>
    </template>
    <div class="actions margin-top-2">
      <Button :disabled="!targetId || busy" :loading="busy" @click="submit">
        {{ plan ? $t('transferRow.confirm') : $t('transferRow.preview') }}
      </Button>
    </div>
  </Modal>
</template>

<script>
import modal from '@baserow/modules/core/mixins/modal'

export default {
  name: 'TransferRowModal',
  mixins: [modal],
  props: {
    database: { type: Object, required: true },
    table: { type: Object, required: true },
    row: { type: Object, required: true },
  },
  emits: ['transferred'],
  data() {
    return { targetId: null, plan: null, busy: false, error: '', requestId: 0 }
  },
  computed: {
    targets() {
      return this.$store.getters['application/getAllOfWorkspace'](
        this.database.workspace
      )
        .filter((app) => app.type === 'database')
        .flatMap((app) =>
          (app.tables || [])
            .filter(
              (table) =>
                table.id !== this.table.id &&
                !table.archived &&
                this.$hasPermission(
                  'database.table.create_row',
                  table,
                  this.database.workspace.id
                )
            )
            .map((table) => ({ ...table, name: `${app.name} / ${table.name}` }))
        )
    },
  },
  watch: {
    'row.id'() {
      this.reset()
    },
    'table.id'() {
      this.reset()
    },
  },
  methods: {
    reset() {
      this.requestId++
      this.targetId = null
      this.plan = null
      this.error = ''
      this.busy = false
    },
    async submit() {
      if (this.busy || !this.targetId) return
      const requestId = ++this.requestId
      const preview = !this.plan
      this.busy = true
      this.error = ''
      try {
        const { data } = await this.$client.post(
          `/database/rows/table/${this.table.id}/${this.row.id}/transfer/`,
          { target_table_id: this.targetId, preview }
        )
        if (requestId !== this.requestId) return
        if (preview) {
          this.plan = data
        } else {
          this.$emit('transferred', data)
          this.$refs.modal.hide()
          this.$bus.$emit('table-refresh', { tableId: this.table.id })
          this.$router.push(data.url)
        }
      } catch (error) {
        if (requestId !== this.requestId) return
        const detail = error.response?.data?.detail
        this.error =
          typeof detail === 'string' ? detail : this.$t('transferRow.error')
        this.plan = null
      } finally {
        if (requestId === this.requestId) this.busy = false
      }
    },
  },
}
</script>
